// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 6/12/2023
 */

.CheckoutSuccess_container__\\+Q-8r {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.CheckoutSuccess_title__yG943 {
    font-size: 1.75rem;
    font-weight: 500;
}

.CheckoutSuccess_icon__o\\+cyI {
    color: #22d3b9;
    font-size: 4rem;
}

.CheckoutSuccess_description__AFukz {
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 1.5rem;
}

.CheckoutSuccess_button__7O2uW {
    border-radius: 0.5rem;
    width: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/CheckoutSuccess.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 6/12/2023\r\n */\r\n\r\n.container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.title {\r\n    font-size: 1.75rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.icon {\r\n    color: #22d3b9;\r\n    font-size: 4rem;\r\n}\r\n\r\n.description {\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.button {\r\n    border-radius: 0.5rem;\r\n    width: 10rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CheckoutSuccess_container__+Q-8r`,
	"title": `CheckoutSuccess_title__yG943`,
	"icon": `CheckoutSuccess_icon__o+cyI`,
	"description": `CheckoutSuccess_description__AFukz`,
	"button": `CheckoutSuccess_button__7O2uW`
};
export default ___CSS_LOADER_EXPORT___;
